import { LocalStorageContainer } from '../../../shared/src/helpers/LocalStorageContainer';

export const PersistentAPIKey = new LocalStorageContainer<{ value: string }, string, string>(
  '__API_KEY__',
  {
    fromLocalStorageModel: ({ value }) => value,
    toLocalStorageModel: value => ({ value }),
  }
);
